import { render, staticRenderFns } from "./BusForm.vue?vue&type=template&id=42c2f0e8&"
import script from "./BusForm.vue?vue&type=script&lang=js&"
export * from "./BusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports